import { css } from '@emotion/react';

export const locationsSearchStyles = {
    inputWrapper: css({
        padding: '8px 16px 0',
    }),
};
